<template>
  <div class="modal-field">
    <button class="modal-field__close-btn" v-if="!modalData.closeOnlyByConfirmButton" @click="closeModal">
      <BaseIcon name="cross" />
    </button>
    <h1 class="modal-field__title" v-html="modalData.title"></h1>
    <div class="modal-field__content" v-if="modalData.description">
      <p class="modal-field__description" v-html="modalData.description"></p>
    </div>

    <div class="modal-field__buttons">
      <BaseButton v-if="modalData.btnTextCancel" :title="modalData.btnTextCancel" @click.native="closeModal"/>
      <BaseButton :title="modalData.btnTextConfirm" @click.native="handleConfirmation" theme="primary"/>
    </div>
  </div>
</template>

<script>
  import { MDSModalConfirmDecisionModel } from '@/models/modal-datasets.model'

  export default {
    props: {
      modalData: MDSModalConfirmDecisionModel,
    },
    methods: {
      closeModal () {
        this.$store.commit('modals/CLOSE_LAST_MODAL')
      },
      handleConfirmation () {
        this.closeModal()
        this.modalData.confirmationHandler()
      },
      handleKeyEvent (e) {
        if (e.keyCode === 13) {
          this.handleConfirmation()
        }
      }
    },
    mounted () {
      document.addEventListener('keydown', this.handleKeyEvent)
    },
    beforeDestroy () {
      document.removeEventListener('keydown', this.handleKeyEvent)
    }
  }
</script>

<style lang="scss" src="./modal-field.scss"></style>



// WEBPACK FOOTER //
// src/components/modals/modals-content/ModalConfirmDecision.vue